<template>
  <div class="flex items-center justify-center">
    <div class="w-6 h-6 border-2 border-gray-300 border-t-primary rounded-full animate-spin"></div>
  </div>
</template>
